<div class="reset-password-container">
  <div class="reset-password-card">
    <div class="reset-password-header">
      <h1>Reset Password</h1>
      <p>Enter your new password</p>
    </div>

    @if (validatingToken) {
      <div class="loading-message">
        Validating reset link...
      </div>
    }

    @if (!validatingToken && !tokenValid) {
      <div class="invalid-token">
        <div class="alert-message error-message">
          {{ errorMessage }}
        </div>
        <div class="back-to-login">
          <a routerLink="/forgot-password">Request a new reset link</a>
        </div>
      </div>
    }

    @if (!validatingToken && tokenValid && errorMessage) {
      <div class="alert-message error-message">
        {{ errorMessage }}
      </div>
    }

    @if (!validatingToken && tokenValid && successMessage) {
      <div class="alert-message success-message">
        {{ successMessage }}
        <div class="redirect-message">Redirecting to login...</div>
      </div>
    }

    @if (!validatingToken && tokenValid) {
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="reset-password-form">
        <div class="form-group">
          <label for="newPassword">New Password</label>
          <input
            type="password"
            id="newPassword"
            formControlName="newPassword"
            placeholder="Enter new password (min 8 characters)"
            [class.error]="newPassword?.invalid && newPassword?.touched"
            />
          @if (newPassword?.invalid && newPassword?.touched) {
            <div class="error-message">
              @if (newPassword?.errors?.['required']) {
                <span>Password is required</span>
              }
              @if (newPassword?.errors?.['minlength']) {
                <span>Password must be at least 8 characters</span>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirm Password</label>
          <input
            type="password"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirm new password"
            [class.error]="confirmPassword?.invalid && confirmPassword?.touched"
            />
          @if (confirmPassword?.invalid && confirmPassword?.touched) {
            <div class="error-message">
              @if (confirmPassword?.errors?.['required']) {
                <span>Please confirm your password</span>
              }
              @if (confirmPassword?.errors?.['passwordMismatch']) {
                <span>Passwords do not match</span>
              }
            </div>
          }
        </div>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="resetPasswordForm.invalid || loading || successMessage"
          >
          {{ loading ? 'Resetting...' : 'Reset Password' }}
        </button>
        <div class="back-to-login">
          Remember your password? <a routerLink="/login">Login</a>
        </div>
      </form>
    }
  </div>
</div>
